export default function useLocalStorage() {
  const getToken = () => localStorage.getItem("access_token");

  return {
    accessToken: getToken(),
  };
}
